import animateScroll from "./animate-scroll";
import events from "./scroll-events";
import utils from "./utils";

let __mapped = {};
let __activeLink: any;

export default {

  unmount: () => {
    __mapped = {};
  },

  register: (name: any, element: any) => {
    __mapped[name] = element;
  },

  unregister: (name: any) => {
    delete __mapped[name];
  },

  get: (name: any) => __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0],

  setActiveLink: (link: any) => __activeLink = link,

  getActiveLink: () => __activeLink,

  scrollTo(to: any, props: any) {
    const target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = { ...props, absolute: false };

    const { containerId } = props;
    const { container } = props;

    let containerElement;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    const { horizontal } = props;
    const scrollOffset = utils.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (events.registered.begin) {
        events.registered.begin(to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (events.registered.end) {
        events.registered.end(to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    animateScroll.animateTopScroll(scrollOffset, props, to, target);
  },
};
